export default "__VITE_ASSET__BBd3vg90__"